define('lib/Podio.Organizations.Create',['require','translate','jquery','lib/Podio.Transport','lib/Podio.UI.Modal','lib/Podio.UI','lib/Podio.Routes','lib/Podio.Event.UI','lib/Podio.FormValidation'],function(require) {

  var t = require('translate');
  var $ = require('jquery');
  var transport = require('lib/Podio.Transport');
  var modal = require('lib/Podio.UI.Modal');
  var podioUI = require('lib/Podio.UI');
  var keyCodes = podioUI.KeyCodes;
  var routes = require('lib/Podio.Routes');
  var eventUI = require('lib/Podio.Event.UI');
  var formValidation = require('lib/Podio.FormValidation');

  function onOrgClicked(elmTarget, e){
    e.preventDefault();

    if ($('#switchermenu').is(':visible')) {
      $('#switcher').click(); // Close space switcher.
    }

    // Hide options navigation if open
    $('#header-global .user-options-navigation').removeClass('active');

    showModal();
  }

  function showModal() {
    var title = t('Create your own organization. It’s free. #org_modal');
    modal.showLoading(title);

    var path = routes.new_organization_path();
    transport.getJSON(path, {}, function(responseData) {
      modal.show(responseData.data.html, {title: title, footerHtml: responseData.data.footer_html});
      setupCreateOrganizationForm();
    });
  }

  function setupCreateOrganizationForm() {
    var elmForm = $('form#new_organization');

    formValidation.init(elmForm);
    elmForm.find('#organization_name').focus();
  }

  function onCreateOrganizationSubmit(elmTarget, e) {
    var elmForm = $('form#new_organization');

    if(elmForm.valid()) {
      var path = elmForm.attr('action');
      var requestData = elmForm.serializeArray();

      modal.showLoading(t('Creating organization #org'));

      transport.postJSON(path, {'requestData': requestData}, function(responseData) {
        if(responseData.status == 'ok') {
          location.href = responseData.data.redirect_to;
          if(responseData.data.redirect_to.split('#')[0] == location.href.split('#')[0]) {
            location.reload();
          }
        } else {
          modal.show(responseData.data.html, {title: t('Create your own organization. It’s free. #org_modal'), footerHtml: responseData.data.footer_html});
          setupCreateOrganizationForm();
        }
      });
    }
  }

  function onCreateOrganizationKeyUp(elmTarget, e) {
    if (e.keyCode == keyCodes.Return) {
      onCreateOrganizationSubmit(elmTarget, e);
    }
  }


  // eventUI.bind('click', '#createorglink,#footer_create_org,#create_org_header,#hoist-free-banner,.js-create-org', onOrgClicked);
  eventUI.bind('click', 'a#create_org_button', onCreateOrganizationSubmit);
  eventUI.bind('submit', '.create-organization-modal form', onCreateOrganizationSubmit);
  eventUI.bind('keyup', '.create-organization-modal form input[type=text]', onCreateOrganizationKeyUp);

});

